import React, { useState, useEffect } from "react";
// import {} from 'react-router-dom'
import { useSelector } from "react-redux";
import { useGetAllObjectiveByPersonId } from "../../Hooks";
import { Grid, Box, Typography, Button } from "@mui/material";
import { AllOKRComponentFace } from "../../Interfaces/Interfaces";
import { ReactComponent as ObjectiveVector } from "../../StaticData/Svgs/ObjectiveVector.svg";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import CreateObjective from "../../Forms/CreateObjective/CreateObjective";
import EditObjective from "../../Forms/EditObjective/EditObjective";
import { CircularProgress } from "@mui/material";
import { useGetAllKeyResultByTenantId
} from '../../../TenantDash/Hooks/index';
import { useNavigate, useParams } from "react-router-dom";
import OKRsCart from "../../../OKRManagment/LComponents/OKRsCart/OKRsCart";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { EditKeyResult } from "../../Forms/EditKeyResult/EditKeyResult";
import { useGetAllPersonPictureByTenantId } from "../../../AllTenantOkrs/Hooks";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const AllKeyResults = ({
  periodId,
  periodsData,
  getObjectiveLoading,
  isFetched,
  filterIsOn,
  afterSuccess
}: AllOKRComponentFace) => {
  const navigate = useNavigate();
  //AMIR
  //const [allObjective, setAllObjective] = useState<any[]>();
  const profileTenantId = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  //AMIR
  //   const {
  //     data: objetcideData,
  //     //isLoading: getObjectiveLoading,
  //     isError,
  //     //isFetched,
  //     refetch: getObjectivesAgain,
  //   } = useGetAllObjectiveByPersonId(periodId, profileTenantId);
  const{data:personPicture,isLoading:loadingg}=useGetAllPersonPictureByTenantId(profileTenantId);
  const [showAddObjective, setShowAddObjective] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [addObjectiveStatus, setAddObjectiveStatus] = useState<any>(null);
  const [showToastMessage3, setShowToastMessage3] = useState<boolean>(false);
  const [krId, setKrId] = useState<any>();
  const [Item, setIteam] = useState<any>();
  // const[allObjective,setAllObjective]=useState<any>(null);
  //const[objectiveAsynOpcState,setObjectiveAsyncOpState]=useState<any>(null);
  const [objectiveAsynOpcState, setObjectiveAsyncOpState] = useState<any>(null);
  const [objectiveId, setObjectiveId] = useState<string | null>(null);
  const[addKrState,setAddKrState]=useState<any>(null);
  const [showEditObjective, setShowEditObjective] = useState<Boolean | null>(
    false
  );
  const{data:keyresultData,isLoading:getKeyresultLoading,refetch:getObjDataAgain}
  =useGetAllKeyResultByTenantId(periodId,profileTenantId)
  const initialAddObjective = (): void => {
    setShowAddObjective((prev) => !prev);
  };
  const[showEditKr,setShowEditKr]=useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه

  useEffect(() => {
    if (krId) {
      setShowEditKr(true)
    }
     
    }, [krId])
  // useEffect(() => {

  //   setAllObjective(objetcideData)

  // }, [objetcideData])

  // useEffect(() => {
  //   if (objectiveId) {
  //     setShowEditObjective(true);
  //   }
  // }, [objectiveId]);

  if (getObjectiveLoading || !keyresultData || isFetched !== true) {
    return (
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"100%"}
        height={"500px"}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Grid container>
        {/* درحالت عدم وجود o */}
        <Grid item xs={12}>
          {keyresultData?.length === 0 && (
            <Grid item xs={12}>
              <Box width={"100%"} textAlign={"center"} p={2}>
                <div className="w-full h-80 flex justify-center">
                  <ObjectiveVector />
                </div>
                {!filterIsOn && (
                  <>
                    <Box mt={3}>
                      <Typography textAlign={"center"} variant="body2">
                        نتیجه کلیدی در این دوره‌‌زمانی تعریف نشده است.
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Grid>
          )}
        </Grid>

        <Grid item xs={12}  px={1.5}>
          {keyresultData.length > 0 && (
            <Grid container>
              <Grid item xs={12} >
                <Grid container spacing={1}>
                  {keyresultData &&
                    keyresultData.map((item: any, i: number) => {
                      return (
                        <Grid item xs={12} sm={4}>
                          <Box
                              key={i}
                              sx={{
                                transition: "all 0.3s ease",
                                "&:hover": {
                                  transform: "scale(1.05)",
                                  backgroundColor: "withesmoke",
              
                                },
                                padding: "10px",
                              }}
                            >
                            <OKRsCart
                              // obj={item}
                              setKrId={setKrId} 
                              setShowEditKr={setShowEditObjective}  
                              setShowToastMessage={setShowToastMessage}
                              afterSuccess={keyresultData}
                              personPicture={personPicture}
                              setObjectiveId={setObjectiveId}
                              item={item}
                              setIteam={setIteam}
                              setObjectiveAsyncOpState={setObjectiveAsyncOpState}
                            />
                          </Box>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
        {
              showEditKr && <ModalLyt 
              showModal={showEditKr}
              setShowModal={setShowEditKr}
              title={'ویرایش نتیجه کلیدی'}
              width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
              height={900}
              >
              <EditKeyResult  
              definitionId = {""}
              setShowEditKeyResult={setShowEditKr}
              editKrSuccess={getObjDataAgain}  
              setShowToastMessage={setShowToastMessage}
              setAddKrState={setAddKrState}
              setShowToastMessage3={setShowToastMessage3}
              krId={krId}
              Item={Item}
          />
          </ModalLyt>
        }
        {showToastMessage && (
          <DYToastMessage
            //isSuccess={addObjectiveStatus?.isSuccess}
            //message={addObjectiveStatus?.metaData.message}
            isSuccess={objectiveAsynOpcState?.isSuccess}
            message={objectiveAsynOpcState?.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {showToastMessage3 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage3}
            show={showToastMessage3}
          />
        )}
      </Grid>
    </>
  );
};

export default AllKeyResults;

// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { Grid, Box, Typography, Button, TextField, IconButton } from "@mui/material";
// import SearchIcon from '@mui/icons-material/Search';
// import { CircularProgress } from "@mui/material";
// import { useGetAllKeyResultByTenantId } from '../../../TenantDash/Hooks/index';
// import OKRsCart from "../../../OKRManagment/LComponents/OKRsCart/OKRsCart";
// import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";

// const AllKeyResults = ({
//   periodId,
//   periodsData,
//   getObjectiveLoading,
//   isFetched,
//   filterIsOn,
//   afterSuccess
// }: AllOKRComponentFace) => {
//   const profileTenantId = useSelector(
//     (state: any) => state.meetings.profileTenantId
//   );

//   const { data: keyresultData, isLoading: getKeyresultLoading } = useGetAllKeyResultByTenantId(periodId, profileTenantId);
  
//   const [searchTerm, setSearchTerm] = useState<string>(""); // برای نگهداری کلمه جستجو
//   const [filteredData, setFilteredData] = useState<any[]>([]); // برای نگهداری داده‌های فیلتر شده

//   // اعمال جستجو
//   const handleSearch = () => {
//     const filtered = keyresultData?.filter((item: any) =>
//       item.name.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredData(filtered);
//   };

//   useEffect(() => {
//     if (keyresultData) {
//       setFilteredData(keyresultData); // بارگذاری داده‌های اولیه
//     }
//   }, [keyresultData]);

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       // اعمال جستجو بعد از 500 میلی‌ثانیه
//       if (keyresultData) {
//         const filtered = keyresultData.filter((item: any) =>
//           item.name?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//         setFilteredData(filtered);
//       }
//     }, 500); // مدت زمان Debounce: 500 میلی‌ثانیه

//     return () => clearTimeout(delayDebounceFn); // پاک کردن تایمر هنگام تایپ
//   }, [searchTerm, keyresultData]);

//   if (getObjectiveLoading || !keyresultData || isFetched !== true) {
//     return (
//       <Box
//         display={"flex"}
//         alignItems={"center"}
//         justifyContent={"center"}
//         width={"100%"}
//         height={"500px"}
//       >
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         {/* فیلد جستجو */}
//         <Box display="flex" alignItems="center" mb={2}>
//           <TextField
//             label="جستجو..."
//             variant="outlined"
//             fullWidth
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <IconButton onClick={() => {}}>
//             <SearchIcon />
//           </IconButton>
//         </Box>
//       </Grid>

//       <Grid item xs={12}>
//         {filteredData.length > 0 ? (
//           <Grid container spacing={1}>
//             {filteredData.map((item: any, i: number) => (
//               <Grid item xs={12} sm={4} key={i}>
//                 <Box
//                   sx={{
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "scale(1.05)",
//                       backgroundColor: "whitesmoke",
//                       boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
//                       borderRadius: "12px",
//                     },
//                     padding: "10px",
//                   }}
//                 >
//                   {/* نمایش داده‌های هر آیتم */}
//                   <div>{item.name}</div>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         ) : (
//           <Box textAlign="center">نتیجه‌ای پیدا نشد.</Box>
//         )}
//       </Grid>
//     </Grid>
//   );
// };

// export default AllKeyResults;

// import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
// import { useGetAllKeyResultByTenantId } from '../../../TenantDash/Hooks/index';
// import { Grid, Box, Typography, CircularProgress, TextField, IconButton } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import OKRsCart from "../../../OKRManagment/LComponents/OKRsCart/OKRsCart";
// import SearchIcon from "@mui/icons-material/Search";
// import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
// import { EditKeyResult } from "../../Forms/EditKeyResult/EditKeyResult";

// const AllKeyResults = ({
//   periodId,
//   periodsData,
//   getObjectiveLoading,
//   isFetched,
//   filterIsOn,
//   afterSuccess
// }: AllOKRComponentFace) => {
//   const navigate = useNavigate();
//   const profileTenantId = useSelector((state: any) => state.meetings.profileTenantId);
//   const { data: keyresultData, isLoading: getKeyresultLoading } = useGetAllKeyResultByTenantId(periodId, profileTenantId);
  
//   const [searchTerm, setSearchTerm] = useState<string>(""); // کلمه جستجو
//   const [filteredData, setFilteredData] = useState<any[]>([]); // داده‌های فیلتر شده
//   const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
//   const [objectiveAsynOpcState, setObjectiveAsyncOpState] = useState<any>(null);
//   const [krId, setKrId] = useState<any>();
//   const [showEditKr, setShowEditKr] = useState<boolean>(false);

//   // Debouncing جستجو
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       if (keyresultData) {
//         const filtered = keyresultData.filter((item: any) =>
//           item.name?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//         setFilteredData(filtered);
//       }
//     }, 500); // مدت زمان تأخیر: 500 میلی‌ثانیه

//     return () => clearTimeout(delayDebounceFn); // پاک کردن تایمر هنگام تایپ
//   }, [searchTerm, keyresultData]);

//   if (getKeyresultLoading || !keyresultData || isFetched !== true) {
//     return (
//       <Box display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"} height={"500px"}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <>
//       <Grid container>
//         {/* جستجو */}
//         <Grid item xs={12}>
//           <Box display="flex" alignItems="center" mb={2}>
//             <TextField
//               label="جستجو..."
//               variant="outlined"
//               fullWidth
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <IconButton onClick={() => {}}>
//               <SearchIcon />
//             </IconButton>
//           </Box>
//         </Grid>

//         {/* نمایش نتایج جستجو */}
//         <Grid item xs={12}>
//           {
//             getKeyresultLoading && (
//                 <Box display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"} height={"500px"}>
//                     <CircularProgress />
//                 </Box>
//                 )
//           }

//           { getKeyresultLoading && filteredData.length === 0 && (
//             <Box width={"100%"} textAlign={"center"} p={2}>
//               <Typography variant="body2">نتیجه‌ای پیدا نشد.</Typography>
//             </Box>
//           )}

//           {filteredData.length > 0 && (
//             <Grid container spacing={1} px={1}>
//               {filteredData.map((item: any, i: number) => (
//                 <Grid item xs={12} sm={4} key={i}>
//                   <Box
//                     sx={{
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "scale(1.05)",
//                         backgroundColor: "whitesmoke",
//                         boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
//                         borderRadius: "12px",
//                       },
//                       padding: "10px",
//                     }}
//                   >
//                     <OKRsCart
//                       setKrId={setKrId}
//                       setShowEditKr={setShowEditKr}
//                       setShowToastMessage={setShowToastMessage}
//                       afterSuccess={keyresultData}
//                       setObjectiveAsyncOpState={setObjectiveAsyncOpState}
//                       item={item}
//                     />
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           )}
//         </Grid>

//         {showToastMessage && (
//           <DYToastMessage
//             isSuccess={objectiveAsynOpcState?.isSuccess}
//             message={objectiveAsynOpcState?.metaData.message}
//             setShow={setShowToastMessage}
//             show={showToastMessage}
//           />
//         )}
//       </Grid>
//     </>
//   );
// };

// export default AllKeyResults;
